export const CURRENCY = '^[0-9]+(.[0-9]{1,2})?$';
export const UPPER_SNAKE_CASE = '^[A-Z0-9]+(?:_[A-Z0-9]+)*$';
export const LOWER_SNAKE_CASE = '^[a-z0-9]+(?:_[a-z0-9]+)*$';
export const ANY_SNAKE_CASE = `^(${UPPER_SNAKE_CASE})|(${LOWER_SNAKE_CASE})$`;
export const CUSTOM_FIELD_CODE = '^c_[a-z0-9]+(?:_[a-z0-9]+)*$';
/** Absolute http(s) URL, e.g. a court-portal link. Requires a scheme + host and disallows whitespace. */
export const HTTP_URL = '^https?://[^\\s/$.?#][^\\s]*$';
